exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/edit-adjunto/edit-adjunto.component.css
// module id = ../../../../../src/app/pages/admin/edit-adjunto/edit-adjunto.component.css
// module chunks = main